import _jsx from "@babel/runtime/helpers/jsx";
import React from 'react';
const atcLogo = '//www.autotrader.com/cm-api/content/static/img/icon/logos/atc-logo-flat.svg';
const atcBlueLogo = '//www.autotrader.com/cm-api/content/static/img/icon/logos/atc-logo-blue.svg';
const title = 'Autotrader Used Cars For Sale - New Cars For Sale - SUVs And Trucks For Sale';
const alt = 'Autotrader Logo';
const brand = function (isTransparent) {
  if (isTransparent === void 0) {
    isTransparent = false;
  }
  const logoSrc = isTransparent ? atcLogo : atcBlueLogo;
  return /*#__PURE__*/_jsx("a", {
    href: "/",
    "aria-label": "Find Cars for Sale at Autotrader"
  }, void 0, /*#__PURE__*/_jsx("img", {
    className: "display-inline-block display-lg-none",
    src: logoSrc,
    width: 110,
    height: 27,
    title: title,
    alt: alt,
    loading: "eager"
  }), /*#__PURE__*/_jsx("img", {
    className: "display-none display-lg-block",
    src: logoSrc,
    width: 139,
    height: 38,
    title: title,
    alt: alt,
    loading: "eager"
  }));
};
const navItems = [{
  eventkey: 1,
  href: '/',
  text: 'Home',
  className: 'display-md-none',
  onEventKey: 'home',
  linkContext: 'HeaderNav',
  glyph: 'home'
}, {
  eventkey: 2,
  href: '/cars-for-sale',
  text: 'Used Cars',
  onEventKey: 'lnkFycUsed',
  linkContext: 'HeaderNav',
  glyph: 'odometer'
}, {
  eventkey: 3,
  href: '/new-cars',
  text: 'New Cars',
  onEventKey: 'lnkFycNew',
  linkContext: 'HeaderNav',
  glyph: 'sparkles'
}, {
  eventkey: 4,
  href: '/cars-for-sale/by-owner',
  text: 'Private Seller Cars',
  onEventKey: 'privateSeller',
  linkContext: 'HeaderNav',
  glyph: 'hand-key'
}, {
  eventkey: 5,
  href: '/sell-my-car',
  text: 'Sell My Car',
  onEventKey: 'lnkSyc',
  linkContext: 'HeaderNav',
  glyph: 'car-tag'
}, {
  eventkey: 6,
  href: '/instant-cash-offer/?LNX=TIMATCHPNAV',
  text: 'Instant Cash Offer',
  onEventKey: 'lnkTim',
  linkContext: 'HeaderNav',
  glyph: 'money'
}, {
  eventkey: 7,
  text: 'Car Research & Tools',
  glyph: 'academic-cap',
  items: [{
    text: 'Helpful Links',
    items: [{
      eventkey: '1',
      href: '/car-deals/best-new-car-deals-281474979990473',
      text: 'Best Car Deals',
      onEventKey: 'lnkBestCarDl',
      destination: 'Car Deals'
    }, {
      eventkey: '2',
      href: '/car-deals/best-truck-deals-281474979990475',
      text: 'Best Truck Deals',
      onEventKey: 'lnkTruckDl',
      destination: 'Truck Deals'
    }, {
      eventkey: '3',
      href: '/car-deals/best-suv-deals-281474979990474',
      text: 'Best SUV Deals',
      onEventKey: 'lnkSuvDl',
      destination: 'SUV Deals'
    }, {
      eventkey: '4',
      href: '/how-to-buy-cars-online',
      text: 'Buy Cars Online',
      onEventKey: 'lnkBcoHdr',
      destination: 'Buy Cars Online'
    }]
  }, {
    text: 'Car Research & News',
    items: [{
      eventkey: '1',
      href: '/research',
      text: 'Research & Information',
      onEventKey: 'lnkCr',
      destination: 'Research Infomation'
    }, {
      eventkey: '2',
      href: '/research/new-model',
      text: 'New & Future Models',
      onEventKey: 'lnkNwFutMdl',
      destination: 'New Future Articles'
    }, {
      eventkey: '3',
      href: '/comparisons/trim-comparisons',
      text: 'Trim Comparisons',
      onEventKey: 'lnkTrimCprs',
      destination: 'Trim Comparisons'
    }]
  }, {
    text: 'Car Buying Tools',
    items: [{
      eventkey: '1',
      href: '/car-shopping',
      text: 'Buying and Selling Tips',
      onEventKey: 'lnkBuyCar',
      destination: 'Buying and Selling Tips'
    }, {
      eventkey: '2',
      href: '/car-payment-calculator',
      text: 'Car Payment Calculator',
      onEventKey: 'lnkMnthPmtCalc',
      destination: 'Car Payment Calculator'
    }, {
      eventkey: '3',
      href: '/car-affordability-calculator',
      text: 'Affordability Calculator',
      onEventKey: 'lnkAfdCalc',
      destination: 'Affordability Calculator'
    }, {
      eventkey: '4',
      href: '/car-lease-calculator',
      text: 'Car Lease Calculator',
      onEventKey: 'lnkLeaseCalc',
      destination: 'Car Lease Calculator'
    }]
  }]
}, {
  eventkey: 8,
  href: '/car-dealers',
  text: 'Find Local Dealers',
  onEventKey: 'lnkFyd',
  linkContext: 'HeaderNav',
  glyph: 'dealership'
}];
const sponsoredContent = [{
  image: {
    alt: 'KBB Insurance market place',
    height: '32px',
    loading: 'lazy',
    lazyload: true,
    src: 'https://www.autotrader.com/content/dam/autotrader/additionalresources/shield_check.svg',
    width: '32px'
  },
  link: {
    href: 'https://www.kbb.com/camp/root-insurance',
    label: 'See if you can save on car insurance on KBB.com'
  },
  onEventKey: 'lnkKbbIM'
}, {
  image: {
    alt: 'Capital One',
    height: '56px',
    loading: 'lazy',
    lazyload: true,
    src: 'https://www.autotrader.com/content/dam/autotrader/additionalresources/capital_one_logo.svg',
    width: '56px'
  },
  link: {
    href: '/camp/car-loans',
    label: 'Pre-qualify for a car loan with no credit score impact'
  },
  sponsoredText: 'SPONSORED',
  partnerType: 'finance',
  partner: 'capital-one',
  name: 'capitalone',
  onEventKey: 'lnkLoan'
}, {
  image: {
    alt: 'KBB',
    height: '32px',
    loading: 'lazy',
    lazyload: true,
    src: 'https://www.autotrader.com/content/dam/autotrader/additionalresources/kbb_logo.svg',
    width: '22px'
  },
  link: {
    href: '/instant-cash-offer/?LNX=TIMATCHPNAVCNR',
    label: 'Get a Kelley Blue Book® Instant Cash Offer'
  },
  onEventKey: 'lnkKbbTim'
}, {
  image: {
    alt: 'AutoCheck',
    height: '40px',
    loading: 'lazy',
    lazyload: true,
    src: 'https://www.autotrader.com/content/static/img/vhr/experian/autocheck-by-kbb-stacked.svg',
    width: '53px'
  },
  link: {
    href: '/camp/vehicle-history-report-vin-check',
    label: 'Run a free AutoCheck Vehicle History Report with Experian'
  },
  name: 'AutoCheck',
  onEventKey: 'lnkAutoCheck',
  enableTriggerSponsorImpression: true
}];
export default {
  brand,
  navItems,
  sponsoredContent
};